/**
 * Small colored pill used for customer tags.
 * - Accessible: contrast-aware text color computed from background.
 * - Compact: fits inline next to names.
 */
export function TagChip({ tag, size = "sm", testId }) {
  const bg = tag?.color || "#64748b";
  const fg = contrastText(bg);
  const cls = size === "xs"
    ? "px-1.5 py-[1px] text-[10px]"
    : "px-2 py-0.5 text-[11px]";
  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold ${cls}`}
      style={{ backgroundColor: bg, color: fg }}
      data-testid={testId || (tag?.id ? `tag-chip-${tag.id}` : undefined)}
    >
      {tag?.name}
    </span>
  );
}

export function TagDot({ tag, size = 6, testId, title }) {
  const bg = tag?.color || "#64748b";
  return (
    <span
      className="inline-block rounded-full ring-2 ring-card"
      style={{ width: size, height: size, backgroundColor: bg }}
      title={title || tag?.name}
      data-testid={testId}
    />
  );
}

function contrastText(hex) {
  // Return white or slate-900 depending on luminance of the background.
  try {
    const h = hex.replace("#", "");
    const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
    const r = parseInt(full.slice(0, 2), 16);
    const g = parseInt(full.slice(2, 4), 16);
    const b = parseInt(full.slice(4, 6), 16);
    // Relative luminance per WCAG
    const [R, G, B] = [r, g, b].map((v) => {
      const s = v / 255;
      return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    });
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L > 0.5 ? "#0f172a" : "#ffffff";
  } catch {
    return "#ffffff";
  }
}
